import {ScriptsProvider} from './providers/scriptsProvider';
import {ConfigProvider} from './config/configProvider';

class SocialLoginButtons
{
    static init() {
        let preloader = document.querySelector('[data-preloader="social-login"]');

        this._initFacebook();
        this._initVkontakte();

        if (preloader) {
            preloader.remove();
        }
    }

    static _initFacebook() {
        let script = 'https://connect.facebook.net/' + ConfigProvider.get('iso_locale') + '/sdk.js',
            buttonElement = document.getElementById('login-fb');

        if (!buttonElement) {
            return;
        }

        ScriptsProvider.add(script, () => {
            FB.init({
                version: ConfigProvider.get('facebook_app_version'),
                appId: ConfigProvider.get('facebook_app_id'),
                cookie: true,
                xfbml: true,
            });

            FB.Event.subscribe('auth.statusChange', (response) => {
                if (response.status === 'connected') {
                    let url = new URL(buttonElement.getAttribute('data-link'));
                    url.searchParams.append('token', response.authResponse.accessToken);

                    window.location.href = url.href;
                }
            });
        });
    }

    static _initVkontakte() {
        let buttonElement = document.querySelector('[data-sosial-login="vkontakte"]');

        if (!buttonElement) {
            return;
        }

        buttonElement.addEventListener('click', (event) => {
            event.preventDefault();
            window.location.href = buttonElement.getAttribute('data-link');
        });

        buttonElement.classList.remove('is-none');
    }
}

export {SocialLoginButtons};
